import { Fragment } from 'react'

import { cn } from '@/utils'
import { NUMBER_MASK } from './accounts'

interface AccountNumberProps {
  numbers: string[]
  className?: string
}

// Four digits on their own read as a number something chopped the front off. The mask says the
// bank printed only these four, and it is quieter than the digits because they are the name.
export const AccountNumber = ({ numbers, className }: AccountNumberProps) => (
  <span className={cn('tabular-nums', className)}>
    {numbers.map((number, index) => (
      <Fragment key={number}>
        {index > 0 ? <span className="text-ink-subtle"> + </span> : null}
        <span className="mr-1 text-ink-subtle">{NUMBER_MASK}</span>
        {number}
      </Fragment>
    ))}
  </span>
)
